import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-1562754966__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 50.85 50.85"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-1562754966__cls-1{fill:none;stroke:#717171;stroke-miterlimit:10;stroke-width:.9px}")
        ])),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M.45.45H50.4V50.4H.45z",
      class: "i-1562754966__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M6.24.45h.9V50.4h-.9ZM12.49.45h.9V50.4h-.9ZM18.73.45h.9V50.4h-.9ZM24.98.45h.9V50.4h-.9ZM31.22.45h.9V50.4h-.9ZM37.47.45h.9V50.4h-.9ZM43.71.45h.9V50.4h-.9Z",
      class: "i-1562754966__cls-1"
    }, null, -1))
  ]))
}
export default { render: render }